export const WINDOW_RESIZE_DEBOUNCE_TIMEOUT = 1000 / 6; // Corresponds to 10 frames at 60 Hz.
